<mat-card appearance="outlined" class="agent-card">
  <mat-card-content>

    <div class="agent-header">
      <mat-icon class="agent-avatar">supervisor_account</mat-icon>
      <div class="agent-header-copy">
        <span class="agent-name">{{ Agent.Agent.LastName }}, {{ Agent.Agent.FirstName }}</span>
        @if (Agent.Agent.BusinessName) {
          <span class="agent-business">{{ Agent.Agent.BusinessName }}</span>
        }
      </div>
      @if (ConnectedPlayerId && isAllowedToEdit) {
        <button mat-icon-button class="agent-remove-btn" (click)="removeFromPlayer()" aria-label="Remove agent">
          <mat-icon>person_remove</mat-icon>
        </button>
      }
    </div>

    @if (Agent.Authorities?.length) {
      <div class="agent-authorities">
        @for (authority of Agent.Authorities; track authority.AuthorityId) {
          <span class="authority" [style.background-color]="authority.BgColor" [style.color]="authority.Color">{{ authority.Name }}</span>
        }
      </div>
    }

    <div class="agent-details">
      @if (Agent.Agent.BusinessCellPhone) {
        <a [href]="'tel:' + Agent.Agent.BusinessCellPhone" class="agent-row">
          <mat-icon class="agent-row-icon">smartphone</mat-icon>
          <span>{{ Agent.Agent.BusinessCellPhone }}</span>
        </a>
      }
      @if (Agent.Agent.BusinessEmail) {
        <a [href]="'mailto:' + Agent.Agent.BusinessEmail" class="agent-row">
          <mat-icon class="agent-row-icon">mail_outline</mat-icon>
          <span>{{ Agent.Agent.BusinessEmail }}</span>
        </a>
      }
      @if (Agent.Agent.BusinessURL) {
        <a [href]="'http://' + Agent.Agent.BusinessURL" target="_blank" class="agent-row">
          <mat-icon class="agent-row-icon">link</mat-icon>
          <span>{{ Agent.Agent.BusinessURL }}</span>
        </a>
      }
      @if (Agent.Agent.BusinessAddress1 || Agent.Agent.BusinessAddressCity) {
        <div class="agent-row agent-address">
          <mat-icon class="agent-row-icon" style="align-self: flex-start;">home</mat-icon>
          <div class="agent-address-lines">
            @if (Agent.Agent.BusinessAddress1) { <span>{{ Agent.Agent.BusinessAddress1 }}</span> }
            @if (Agent.Agent.BusinessAddress2) { <span>{{ Agent.Agent.BusinessAddress2 }}</span> }
            @if (Agent.Agent.BusinessAddress3) { <span>{{ Agent.Agent.BusinessAddress3 }}</span> }
            @if (Agent.Agent.BusinessAddressCity) { <span>{{ Agent.Agent.BusinessAddressPO }}&nbsp;{{ Agent.Agent.BusinessAddressCity }}</span> }
            @if (Agent.Agent.BusinessAddressCountry) { <span>{{ Agent.Agent.BusinessAddressCountry }}</span> }
          </div>
        </div>
      }
    </div>

  </mat-card-content>
</mat-card>
